import React from "react";
import "./HospitalBredcrumb.css";
const HospitalBredcrumb = () => {
  return (
    <header className="hospital-bredcrumb">
      <h1>Onboard Your Hospital in 5 Easy Steps!</h1>
      <p>🏆 Complete all steps and unlock your Accredited Partner Badge</p>
    </header>
  );
};

export default HospitalBredcrumb;
